// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__246ct","cell":"ColumnAccessor_cell__3Yd2O","firstCellAccent":"ColumnAccessor_firstCellAccent__2F4g2"};